import Element from "../element";
import DateHelper from "../../../lib/date-helper";

export default class FormField extends Element {
	constructor(props) {
		super(props);

		this.name = props.name;
		this.sendable = props.sendable == null ? true : props.sendable;
		this.cacheable = props.cacheable == null ? false : props.cacheable;
		this.pattern = props.pattern || null;
		this.hidden = props.hidden == null ? false : props.hidden;
		this.required = false;
		this.status = null;
		this.value = null;
		this.isValid = false;

		this.VALUE_CHANGE_EVENT = 'valueChange';
		this.STATUS_CHANGE_EVENT = 'statusChange';
	}

	init() {
		if (!this.$root) {
			throw new Error('FormField: Root element is not defined!');
		}

		if (!this.name) {
			throw new Error('FormField: Name is not defined!');
		}

		if (this.props.cacheable === true || this.props.cacheable === false) {
			this.cacheable = this.props.cacheable;
		} else {
			this.cacheable = (this.$root.dataset.cacheable && this.$root.dataset.cacheable === 'true');
		}

		if (this.props.required === true || this.props.required === false) {
			this.required = this.props.required;
		} else {
			this.required = (this.$root.dataset.required && this.$root.dataset.required === 'true');
		}

		this.status = this.$root.dataset.status || 'neutral';

		if (this.props.value) {
			this.setValue(this.params.value);
		}

		if (this.required) {
			if (this.pattern && Array.isArray(this.pattern)) {
				if (this.pattern.some((pattern) => !(pattern instanceof RegExp))) {
					throw new TypeError('FormField: Wrong type of pattern. Pattern must be an instance of RegExp or array of instances of RegExp!');
				}
			} else if (this.pattern && !(this.pattern instanceof RegExp)) {
				throw new TypeError('FormField: Wrong type of pattern. Pattern must be an instance of RegExp or array of instances of RegExp!');
			}

			this.validateSoft();
		}

		if (this.$root.dataset && this.$root.dataset.workingHoursOnly === 'true') {
			DateHelper.areWorkingHours().then((areWorkingHours) => {
				if (!areWorkingHours) {
					this.$root.classList.remove('-hidden');
				}
			});
		}

		if (this.hidden) {
			this.hide();
		}

		super.init();
	}

	findInputByName() {
		if (!this.name) {
			throw new Error('FormField: Name is not defined!');
		}

		this.$input = this.$root.querySelector(`input[name="${this.name}"]`);

		if (!this.$input) {
			throw new Error('FormField: Input element is not defined!');
		}
	}

	validate() {}

	validateSoft() {
		this.validate();
		if (this.isValid) {
			this.setStatus('valid');
		} else {
			this.setStatus('neutral');
		}
	}

	validateStrict() {
		this.validate();
		if (this.isValid) {
			this.setStatus('valid');
		} else {
			this.setStatus('invalid');
		}
	}

	setStatus(value) {
		if (this.status == value) return;

		this.status = value;

		if (this.$root.dataset.status) {
			this.$root.dataset.status = value;
		}

		this.dispatchEvent(this.STATUS_CHANGE_EVENT, this.status);
	}

	setValue(value) {
		this.value = value;
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	getValue() {
		return this.value;
	}

	setInitialValue(value) {
		if (!value) return;

		this.setValue(value);
		this.refreshInputValue();
	}

	refreshInputValue() {
		if (!this.$input) return;

		this.$input.value = this.value;
		this.$input.dispatchEvent(new Event('input'));
	}

	setInitialState() {}

	/*
	 * @return array({ name: value })
	 */
	getData() {
		if (this.name == null || this.value == null) {
			return null;
		}

		return { [this.name]: this.value };
	}

	hide(shouldValidate = true) {
		this.$root.classList.add('-hidden');
		this.hidden = true;

		if (shouldValidate) {
			this.validate();
		}
	}

	show(shouldValidate = true) {
		this.$root.classList.remove('-hidden');
		this.hidden = false;

		if (shouldValidate) {
			this.validate();
		}
	}

	getLabel() {
		return this.$root.querySelector('label').textContent;
	}
}